module.exports = {
	"sitedownloads": "",
	"masterplan": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/data/masterplan",
	"stageplan": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/data/stageplan",
	"lotplan": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/data/lotplan",
	"searchfields": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/data/searchfields",
	"packagesearch": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/data/packagesearch",
	"package": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/data/package",
	"location": "",
	"spacerimage": "https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/assets/images/spacer.png",
	"googlemapsapikey": "",
	"activestatus": [
		1,
		3
	],
	"landforsalepath": "/land-for-sale",
	"houseandlandpath": "/house-and-land"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/config.json
 ** module id = 21
 ** module chunks = 0
 **/